<template>
<div class="chapter">
<div class="inner_page">
<p class="OT"><a id="page_v">Contents</a></p><a id="page_v">
</a><p class="TocSb1" id="for"><a id="page_v"></a><a href="#/xhtml/foreword#for">Foreword</a></p>
<p class="Toc1a"><a href="#/xhtml/foreword#for">by Thomas G. Long</a></p>
<p class="Toc1b" id="int"><a href="#/xhtml/introduction#int">Introduction</a></p>
<p class="Toc" id="ch-001"><span href="#/xhtml/chapter001#ch001" title="Link target outside of Sample">1.<span class="space1">MONDAY</span></span></p>
<p class="Toc1"><span href="#/xhtml/chapter001#ch001" title="Link target outside of Sample">Listening</span></p>
<p class="Toc" id="ch-002"><span href="#/xhtml/chapter002#ch002" title="Link target outside of Sample">2.<span class="space1">TUESDAY</span></span></p>
<p class="Toc1"><span href="#/xhtml/chapter002#ch002" title="Link target outside of Sample">Hearing</span></p>
<p class="Toc" id="ch-003"><span href="#/xhtml/chapter003#ch003" title="Link target outside of Sample">3.<span class="space1">WEDNESDAY</span></span></p>
<p class="Toc1"><span href="#/xhtml/chapter003#ch003" title="Link target outside of Sample">Exegeting</span></p>
<p class="Toc" id="ch-004"><span href="#/xhtml/chapter004#ch004" title="Link target outside of Sample">4.<span class="space1">THURSDAY</span></span></p>
<p class="Toc1"><span href="#/xhtml/chapter004#ch004" title="Link target outside of Sample">Naming</span></p>
<p class="Toc" id="ch-005"><span href="#/xhtml/chapter005#ch005" title="Link target outside of Sample">5.<span class="space1">REFLECTING</span></span></p>
<p class="Toc1"><span href="#/xhtml/chapter005#ch005" title="Link target outside of Sample">A Pastor Looks Back</span></p>
<p class="Toc" id="ch-006"><a id="page_vi"></a><span href="#/xhtml/chapter006#ch006" title="Link target outside of Sample">6.<span class="space1">FRIDAY</span></span></p>
<p class="Toc1"><span href="#/xhtml/chapter006#ch006" title="Link target outside of Sample">Writing</span></p>
<p class="Toc" id="ch-007"><span href="#/xhtml/chapter007#ch007" title="Link target outside of Sample">7.<span class="space1">SATURDAY</span></span></p>
<p class="Toc1"><span href="#/xhtml/chapter007#ch007" title="Link target outside of Sample">Rehearsing</span></p>
<p class="Toc" id="ch-008"><span href="#/xhtml/chapter008#ch008" title="Link target outside of Sample">8.<span class="space1">SUNDAY</span></span></p>
<p class="Toc1"><span href="#/xhtml/chapter008#ch008" title="Link target outside of Sample">Offering</span></p>
<p class="Toc2" id="epig"><span href="#/xhtml/epilogue#epig" title="Link target outside of Sample">Epilogue</span></p>
<p class="Toc1b" id="note"><span href="#/xhtml/notes#note" title="Link target outside of Sample">Notes</span></p>
<p class="Toc1b" id="bib"><span href="#/xhtml/bibliography#bib" title="Link target outside of Sample">Bibliography</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?6e0b1665